import { string } from 'yup';
import { FieldType } from '@widgets/EnquiryForm/types/config';
export const generateEmailSchemaObject = ({ type, required }) => {
    if (type !== FieldType.EmailInput)
        return null;
    let fieldValidation = string().email('Please enter a valid email');
    if (required) {
        fieldValidation = fieldValidation.required('This is a required field');
    }
    return fieldValidation;
};
